<template>
    <div >
    <v-toolbar
    class="toolbar"
    right
    dir="rtl"
      image="https://img.freepik.com/free-vector/modern-flowing-colorful-wave-banner-background_1035-19861.jpg?t=st=1729530693~exp=1729534293~hmac=14a5069c62db15c19c1209d148af956182da18c2a6de644e9b149280d4ac419e&w=1380"
      dark
      prominent
    >
    <v-toolbar-title   ><router-link to='/' class=" title"><h2 >Resin Arts</h2></router-link></v-toolbar-title>    
    </v-toolbar>
   
 
    </div>
</template>
<style>
.title{
    font-family: 'Times New Roman', Times, serif;
    color: rgb(107, 65, 107);
     text-align: center;
     text-decoration: none;
  
}



</style>
